
(function () {
  'use strict';

  var RSI_BUTTONS = [
    '#rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '[id^="rsi"] button'
  ];
  function releasitButton() {
    for (var i = 0; i < RSI_BUTTONS.length; i++) {
      var el = document.querySelector(RSI_BUTTONS[i]);
      if (el && !el.closest('[data-ms-order]')) return el;
    }
    return null;
  }
  function order() {
    var btn = releasitButton();
    if (btn) { btn.click(); return; }
    try {
      var v2 = window._rsiV2;
      if (v2 && typeof v2.setState === 'function') { v2.setState({ isOpen: true }); return; }
    } catch (e) {}
    var form = document.querySelector('product-form, .product-form, product-info');
    if (form) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ms-order]') : null;
    if (!t) return;
    e.preventDefault();
    order();
  });

  var sent = {};
  function emit(name, detail, key) {
    if (sent[key]) return;
    sent[key] = true;
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {}
  }
  document.addEventListener('rsi::v2::update', function (e) {
    var d = (e && e.detail) || {};
    if (d.orderResponse) emit('ms:commande_passee', { order: d.orderResponse }, 'order');
    else if (d.isOpen) emit('ms:formulaire_ouvert', {}, 'open');
  });

  function sliders() {
    document.querySelectorAll('ul.slider').forEach(function (s) {
      if (s.hasAttribute('tabindex') || s.querySelector('a, button, input, select, textarea, [tabindex]')) return;
      s.setAttribute('tabindex', '0');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sliders); else sliders();
})();

(function () {
  'use strict';
  var imgs = Array.prototype.slice.call(document.querySelectorAll('img[data-ms-src]'));
  if (!imgs.length) return;
  function charger(img) {
    if (!img.hasAttribute('data-ms-src')) return;
    if (img.getAttribute('data-ms-srcset')) img.setAttribute('srcset', img.getAttribute('data-ms-srcset'));
    img.setAttribute('src', img.getAttribute('data-ms-src'));
    img.removeAttribute('data-ms-src');
    img.removeAttribute('data-ms-srcset');
  }
  var parti = false;
  function partir() {
    if (parti) return;
    parti = true;
    if (!('IntersectionObserver' in window)) { imgs.forEach(charger); return; }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); charger(e.target); } });
    }, { rootMargin: '300px 0px' });
    imgs.forEach(function (img) { io.observe(img); });
  }
  var ouvertures = Array.prototype.slice.call(document.querySelectorAll('.ms-cats--ouverture img, [data-ms="hero"] img'))
    .filter(function (img) { return !(img.complete && img.naturalWidth > 0); });
  if (ouvertures.length) {
    var reste = ouvertures.length;
    var fin = function () { reste -= 1; if (reste <= 0) partir(); };
    ouvertures.forEach(function (img) {
      img.addEventListener('load', fin, { once: true });
      img.addEventListener('error', fin, { once: true });
    });
    setTimeout(partir, 4000);
  } else {
    partir();
  }
})();

(function () {
  'use strict';
  var imgs = Array.prototype.slice.call(document.querySelectorAll('img[data-ms-galerie-src]'));
  if (!imgs.length) return;
  var parti = false;
  function partir() {
    if (parti) return;
    parti = true;
    imgs.forEach(function (img) {
      if (img.getAttribute('data-ms-galerie-srcset')) img.setAttribute('srcset', img.getAttribute('data-ms-galerie-srcset'));
      img.setAttribute('src', img.getAttribute('data-ms-galerie-src'));
      img.removeAttribute('data-ms-galerie-src');
      img.removeAttribute('data-ms-galerie-srcset');
    });
  }
  var premiere = document.querySelector('media-gallery .product__media-item img:not([data-ms-galerie-src])');
  if (premiere && !(premiere.complete && premiere.naturalWidth > 0)) {
    premiere.addEventListener('load', partir, { once: true });
    premiere.addEventListener('error', partir, { once: true });
    setTimeout(partir, 4000);
  } else {
    partir();
  }
})();

(function () {
  'use strict';
  if (!window.customElements || !document.querySelector('product-info [data-ms="couleurs"]')) return;

  customElements.whenDefined('product-info').then(function () {
    var proto = customElements.get('product-info').prototype;
    var dawn = proto.updateMedia;
    if (typeof dawn !== 'function' || proto.msOrdreFixe) return;
    proto.msOrdreFixe = true;
    var ids = function (ul) {
      return Array.prototype.map.call(ul.querySelectorAll('li[data-media-id]'), function (li) { return li.dataset.mediaId; }).sort().join();
    };
    proto.updateMedia = function (html, idPhoto) {
      var galerie = this.querySelector('media-gallery');
      var ici = galerie && galerie.querySelector('ul');
      var recue = html && html.querySelector('media-gallery ul');
      if (!idPhoto || !this.querySelector('[data-ms="couleurs"]') || !ici || !recue || ids(ici) !== ids(recue) || typeof galerie.setActiveMedia !== 'function') {
        return dawn.apply(this, arguments);
      }
      galerie.setActiveMedia(this.dataset.section + '-' + idPhoto, false);
    };
  });

  function brancher(info) {
    var galerie = info.querySelector('media-gallery');
    var section = info.dataset.section;
    if (!galerie || !section || galerie.hasAttribute('data-ms-couleurs')) return;
    galerie.setAttribute('data-ms-couleurs', '');
    var geste = 0;
    var marquer = function () { geste = Date.now(); };
    ['pointerdown', 'touchstart', 'touchmove', 'touchend', 'wheel', 'keydown'].forEach(function (t) {
      galerie.addEventListener(t, marquer, { passive: true });
    });
    var attente = null;
    var nous = false;
    function choisir(idGalerie) { // « <section>-<id de la photo> »
      var couleurs = info.querySelector('[data-ms="couleurs"]');
      if (!couleurs || !idGalerie || idGalerie.indexOf(section + '-') !== 0) return;
      var input = couleurs.querySelector('input[data-ms-media="' + idGalerie.slice(section.length + 1) + '"]');
      if (!input || input.checked) return;
      var vrai = input.id;
      input.id = vrai + '-ms';
      input.checked = true;
      nous = true;
      try { input.dispatchEvent(new Event('change', { bubbles: true })); } finally { nous = false; input.id = vrai; }
    }
    function poserVariante(input) {
      var id = input.getAttribute('data-ms-variant');
      if (!id) return;
      info.querySelectorAll('#product-form-' + section + ', #product-form-installment-' + section).forEach(function (form) {
        var champ = form.querySelector('input[name="id"]');
        if (!champ || champ.value === id) return;
        champ.value = id;
        champ.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    function montrer(input) {
      var photo = input.getAttribute('data-ms-media');
      if (photo && typeof galerie.setActiveMedia === 'function') galerie.setActiveMedia(section + '-' + photo, false);
    }
    info.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-ms="couleurs"] input[type="radio"]');
      if (!input) return;
      poserVariante(input);
      if (nous) return;
      montrer(input);
      clearTimeout(attente);
      geste = 0;
    });
    var viewer = galerie.querySelector('[id^="GalleryViewer"]');
    var liste = viewer && viewer.querySelector('[id^="Slider-"]');
    if (liste) liste.addEventListener('scroll', function () {
      clearTimeout(attente);
      attente = setTimeout(function () {
        if (Date.now() - geste > 1500) return;
        var items = Array.prototype.filter.call(liste.querySelectorAll('li[data-media-id]'), function (li) { return li.clientWidth > 0; });
        if (items.length < 2) return;
        var pas = items[1].offsetLeft - items[0].offsetLeft;
        if (pas <= 0) return;
        var i = Math.min(items.length - 1, Math.max(0, Math.round(liste.scrollLeft / pas)));
        choisir(items[i].dataset.mediaId);
      }, 180);
    }, { passive: true });
    galerie.addEventListener('click', function (e) {
      var mini = e.target.closest && e.target.closest('[id^="GalleryThumbnails"] [data-target]');
      if (mini) choisir(mini.getAttribute('data-target'));
    });
  }
  document.querySelectorAll('product-info').forEach(brancher);
})();
